import { render, staticRenderFns } from "./ForgotPasswordCsr.vue?vue&type=template&id=6f530f6a&scoped=true"
import script from "./ForgotPasswordCsr.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCsr.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCsr.vue?vue&type=style&index=0&id=6f530f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f530f6a",
  null
  
)

export default component.exports